<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content buddy-content" @click="closeLevel2()">
      <student-header class="filled" :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">Onboarding</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">Тайлан</li>
              </ol>
            </nav>
          </div>

          <div class="d-flex align-items-center mg-b-20">
            <div class="d-flex align-items-center tx-14 tx-semibold">
              <div @click="filterByMode(0)" role="button" :class="`${filter.mode==0 ? 'bg-primary tx-white':'bg-white'} rounded pd-x-20 pd-y-5`">Бүгд</div>
              <div @click="filterByMode(1)" role="button" :class="`${filter.mode==1 ? 'bg-primary tx-white':'bg-white'} rounded pd-x-20 pd-y-5 mg-x-10`">1 сар</div>
              <div @click="filterByMode(2)" role="button" :class="`${filter.mode==2 ? 'bg-primary tx-white':'bg-white'} rounded pd-x-20 pd-y-5`">3 сар</div>
              <div @click="exportNewbies()" role="button" class="rounded mg-l-10 bg-success pd-x-10 pd-y-4">
                <!-- exportObj.modal= true -->
                <feather type="file" class="tx-white" style="width:20px"></feather>
              </div>
            </div>
            <div class="mg-l-auto d-flex align-items-center">
              <div class="wd-150">
                <DatePicker
                  v-model="filter.startDate"
                  class="buddy-date"
                  placeholder="Эхлэх"
                  type="date"
                  style="width: 100%"
                  :format="'yyyy-MM-dd'"
                  :value-format="'yyyy-MM-dd'"
                ></DatePicker>
              </div>
              <div class="mg-x-10">
                <feather type="arrow-right" class="tx-primary" style="width: 20px; height: 20px; font-weight: 600"></feather>
              </div>
              <div class="wd-150">
                <DatePicker
                  v-model="filter.endDate"
                  class="buddy-date"
                  placeholder="Дуусах"
                  type="date"
                  style="width: 100%"
                  :format="'yyyy-MM-dd'"
                  :value-format="'yyyy-MM-dd'"
                ></DatePicker>
              </div>
              <div class="mg-l-10">
                <div @click="handleFltr()" class="buddy-btn pd-x-30 pd-y-8 tx-white tx-semibold">
                  Хайх
                  <feather type="search" ></feather>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="check-outer wd-100p">
            <div v-for="(m, i) in $store.state.buddy.boxSummary" :class="`tx-white mg-b-10 check-item check-code-${m.code} pd-x-40 pd-y-20`" >
              <div class="text-center tx-semibold tx-16 mg-b-10 check-title">{{ m.boxName }}</div>
              
              <vc-donut
              :sections="[
                {
                  value: 21,
                  color: 'white',
                },
              ]"
              :background="getFieldFromConstants('bgColor', m)"
              :foreground="getFieldFromConstants('borderColor', m)"
              :size="80"
              unit="%"
              :thickness="12"
              :total="100"
              :start-angle="0"
            >
              <div class="tx-semibold">
                <div class="tx-lg-28 tx-md-20 tx-sm-16 tx-xs-14 tx-white">
                  21%
                </div>
                <div class="tx-lg-16 tx-md-14 tx-sm-12 tx-xs-8 tx-color-04">2512/615</div>
              </div>
            </vc-donut>

              <div @click="$router.push({name: 'buddyAdminReportDetail', params: {id: m.code}})" role="button" style="left: 50%; transform: translate(-50%, 0%); border-radius: 30px;" class="text-center chk-more pos-absolute b-30 bg-white-1 tx-16 tx-semibold pd-x-40 pd-y-10">Дэлгэрэнгүй</div>
            </div>
          </div> -->

          <budd-levels @on-detail="onLevelsDetail"></budd-levels>

          <div class="d-flex mg-t-20">
            <div class="mg-l-auto">
              <depart-cascader class="wd-400" size="large" v-model="filter.departId" @on-change="departChanged" checkStrictly></depart-cascader>
            </div>
          </div>

          <newbies ref="rfNewbiews" :filterModelProp="filter"></newbies>

        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>


    <b-modal v-model="exportObj.modal" centered hide-footer title="Экспорт">
      <div class="buddy-content">
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Гарчиг</label>
          <input class="form-control" />
        </div>
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Хүсэлт гаргасан ажилтны домайн</label>
          <input class="form-control" />
        </div>
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Агуулга</label>
          <textarea class="form-control" rows="5"></textarea>
        </div>

        <div class="tx-semibold tx-16">
          <div class="text-center rounded btn-block mg-b-10 bd pd-x-10 pd-y-10">
            <div @click="exportNewbies()" class="d-flex align-items-center justify-content-center">
              <div class="rounded mg-r-10 bg-success pd-x-10 tx-white pd-y-4"><feather type="file"></feather></div>
              Тайлан татах
            </div>
          </div>
          <div class="text-center rounded btn-block pd-10 buddy-bg tx-white">Бүртгэх</div>
        </div>
      </div>
    </b-modal>

    <file-dialog
        :show="fileDialog.show"
        :id="fileDialog.id"
        @on-hide="fileDialog.show = false"
      />

    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, DatePicker } from "element-ui";

import contstants from "@/constants";

export default {
  components: {
    DatePicker,
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    newbies: () => ({
      component: import("@/views/modules/lms/student/buddy/components/newbies.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    buddLevels: () => ({
      component: import("@/views/modules/lms/student/buddy/components/levels.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      exportObj:{
        modal: false
      },
      filter:{
        startDate: null,
        endDate: null,
        mode: 0,
        departId: null,
      },
      modules:[
        {title: 'Ажлын эхний өдөр', perc: 21, all: 2512, done: 615 },
        {title: 'Ажлын эхний 7 хоног', perc: 21, all: 2512, done: 615 },
        {title: 'Ажлын эхний 30 хоног', perc: 21, all: 2512, done: 615 },
        {title: 'Ажлын эхний 60-90 хоног', perc: 21, all: 2512, done: 615 },
      ],
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      buddyLevels: contstants.levels,
      fileDialog: {
        id: null,
        show: false,
      },
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
    this.$store.dispatch('buddy/handleBoxNames',{ store: this.$store });
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    openFile(id){
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    exportNewbies() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/ExportNewbies" },
        data: {
          filter: this.filter
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.exportObj.modal= false;
          this.openFile(res.data.file.id);
          // console.log('res newbie export', res);
        }
      });
    },
    filterByMode(mode){
      this.filter.mode= mode;
      if(mode==0){
        this.filter.startDate= null;
        this.filter.endDate= null;
      } else if(mode==1){
        const today = moment(); 
        const startDate = today.clone().subtract(1, 'months');
        this.filter.startDate=  startDate.format('YYYY-MM-DD');
        this.filter.endDate= today.format('YYYY-MM-DD');
      } else if(mode==2){
        const today = moment(); 
        const startDate = today.clone().subtract(3, 'months');
        this.filter.startDate=  startDate.format('YYYY-MM-DD');
        this.filter.endDate= today.format('YYYY-MM-DD');
      }

      this.handleFltr();
    },
    handleFltr(){
      let self= this;
      let _obj=this.$store.state.buddy.boxSummaryFilter;
      // console.log('_obj in store', _obj);
      Object.keys(this.filter).forEach(key => {
        if (_obj[key] !== undefined) {
          _obj[key] = self.filter[key];
          // console.log(`_obj[${key}] updated to`, _obj[key], 'from self.filter:', self.filter[key]);
        } else {
          // console.log(`_obj[${key}] is undefined, skipping update`);
        }
      });

      this.toggleBodyClass("addClass", "dynamic-locker");
      this.$store.dispatch('buddy/handleBoxSummary',{
        filter: _obj,
        store: this.$store
      }).then((res)=>{
        this.toggleBodyClass("removeClass", "dynamic-locker");
      });

      this.$refs.rfNewbiews.initBefore();

      // Object.keys(state.boxSummaryFilter).forEach(key => {
      //     state.boxSummaryFilter[key] = null;
      //   });

      //   let _obj=this.$store.state.buddy.boxNamesFilter;
      // _obj.departId= e;
    },
    onLevelsDetail(level){
      this.$router.push(
        {
          name: 'buddyAdminReportDetail', 
          params: {id: level.code}
        }
      );
    },
    getFieldFromConstants(field, level){
      let rv='';
      if(this.buddyLevels.filter(x=>x.code==level.code).length ){
        rv= this.buddyLevels.filter(x=>x.code==level.code)[0][field];
      }
      return rv
    },
    departChanged(e){
      let _obj=this.$store.state.buddy.boxNamesFilter;
      _obj.departId= e;
      this.$store.dispatch('buddy/handleBoxNames',{
        filter: _obj,
        store: this.$store
      });

      // console.log('departChanged', e);
      this.filter.departId= e;
      this.$refs.rfNewbiews.initBefore();

      //level update
      this.handleFltr();

      this.init();
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      // this.toggleBodyClass("addClass", "dynamic-locker");
      // request({
      //   api: { method: "POST", url: "buddy/admin/GetBoxSummary" },
      //   // data: { },
      //   store: this.$store,
      // }).then((res) => {
      //   this.toggleBodyClass("removeClass", "dynamic-locker");
      //   if(res!=false){
      //     this.modules= res.data.list;
      //   }
      // });
    },
    
  },
};
</script>